module.exports = __webpack_public_path__ + "static/img/platinum 3.98a3e05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/platinum 3.png
// module id = Lzq2
// module chunks = 35